import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type ViewPayload = {
  path: string;
  scopeType: 'page' | 'blog_post' | 'guide' | 'shop' | 'product';
  scopeKey: string;
};

function resolveViewPayload(pathname: string): ViewPayload {
  if (pathname.startsWith('/blog/')) {
    const slug = decodeURIComponent(pathname.slice('/blog/'.length));
    return { path: pathname, scopeType: 'blog_post', scopeKey: slug || pathname };
  }

  if (pathname.startsWith('/guides/')) {
    const slug = decodeURIComponent(pathname.slice('/guides/'.length));
    return { path: pathname, scopeType: 'guide', scopeKey: slug || pathname };
  }

  if (pathname === '/features') {
    return { path: pathname, scopeType: 'shop', scopeKey: 'shop-home' };
  }

  return { path: pathname, scopeType: 'page', scopeKey: pathname };
}

export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const payload = resolveViewPayload(location.pathname);
    const sessionKey = `page_view:${payload.scopeType}:${payload.scopeKey}`;
    if (sessionStorage.getItem(sessionKey) === '1') {
      return;
    }

    sessionStorage.setItem(sessionKey, '1');

    void fetch('/api/analytics/page-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      keepalive: true,
      body: JSON.stringify(payload),
    }).catch(() => {
      sessionStorage.removeItem(sessionKey);
    });
  }, [location.pathname]);

  return null;
}
